<template>
	<div>
		<div class="row py-3 mb-3 shadow">
			<div class="col-10 offset-1">
				<Navigation/>
			</div>
		</div>
		<div class="row mt-5 mb-5">
			<div class="col-1 text-right">
				<!-- TOOLBAR LEFT -->
				<h1 v-if="$router.currentRoute.path.split('/').length > 3"
					@click="$router.back()"
				><i class="fas fa-chevron-left"></i></h1>
			</div>
			<div class="col-10">
				<router-view/>
			</div>
			<div class="col-1">
				<!-- TOOLBAR RIGHT -->
			</div>
		</div>
	</div>
</template>

<script>
	import Navigation from "../../components/admin/Navigation";
	import {mapActions} from "vuex";

	export default {
		name: "Admin",
		components: {Navigation},
		created() {
			// this.refreshBottles();
			// this.refreshUsers();
			// this.refreshCustomers();
		},
		methods: {
			// ...mapActions(['refreshBottles', 'refreshUsers', 'refreshCustomers'])
		}
	}
</script>

<style scoped>

</style>
